import { Component, OnInit } from '@angular/core';
import { AgreementDto } from '@models/users/agreement.dto';
import { AccountService } from '@services/account.service';
import { AgreementService } from '@services/agreement.service';
import { isEmpty } from '@utils/is-empty.function';

@Component({
  selector: 'ebs-agreement-view',
  templateUrl: './agreement-view.component.html',
  styleUrls: ['./agreement-view.component.scss'],
})
export class AgreementViewComponent implements OnInit {
  public agreements: AgreementDto[] = [];
  selectedNodes: AgreementDto | null = null;
  public fileSrc: any = undefined;

  public get code(): string {
    return this.accountService.user!.externalCode!;
  }

  public showCode: boolean = false;

  public get name(): string {
    let name = '';
    if (!isEmpty(this.selectedNodes?.businessName)) {
      name = this.selectedNodes!.businessName!;
    } else if (!isEmpty(this.selectedNodes?.lastName)) {
      name = `${isEmpty(this.selectedNodes?.jobTitle) ? '' : this.selectedNodes?.jobTitle + ' '}${this.selectedNodes?.name} ${this.selectedNodes?.lastName}`;
    }
    return name;
  }

  constructor(
    private accountService: AccountService,
    private agreementService: AgreementService,
  ) {}
  ngOnInit(): void {
    this.loadUsers();
  }

  loadUsers() {
    this.agreementService.getAgreementView().subscribe((result) => {
      this.agreements = result;
    });
  }

  selectDetails(agreement: AgreementDto) {
    this.agreementService
      .downloadAgreementPoster(agreement.agreementId!)
      .subscribe(async (result: Blob) => {
        if (result.size > 0) {
          this.fileSrc = result;
        }

        this.selectedNodes = agreement;
      });
  }

  onDetailClosed() {
    this.selectedNodes = null;
    this.fileSrc = undefined;
  }
}
